import {getSeries} from 'utils/tool';
export const getChartSeries = (dataConfigs)=>{
    return function(chartData){
        const xdata = [];
        dataConfigs.forEach(item=>{
            item.data = [];
        });
        chartData.forEach(item=>{
            xdata.push(item.day);
            dataConfigs.forEach(one=>{
                one.data.push(item[one.key]);
            });

        });
        const series = dataConfigs.map(item=>{
            return getSeries(item.data,item.name,item.color);
        });
        return {xdata,series};
    };
};



// WEBPACK FOOTER //
// ./src/utils/consumptionTool.js